import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { Values } from "../../../values/values";

@Injectable()
export class EndpointRustService {
  private URL = Values.ROOT_URL_RUST + '/';

  private reqPattern = Values.API_REQ_PATTERN;
  
  constructor(private http: HttpClient) {}

  public loadTableDisplays(body: any): any {
    const requestURL = this.URL + "table-displays";

    return this.http.post(
      requestURL,
      body,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    ).pipe(map((response) => response));
  }

  public searchGeneric(value, idCompany, labelLanguage): any {
    const requestURL = this.URL + "search-generic";
    let body = {value, idCompany, labelLanguage};
    return this.http.post(
      requestURL,
      body,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    ).pipe(map((response) => response));
  }

  //public getStructure(data, paramControlVariables, paramsExternalWindow = false) {
  public getStructure(data, paramControlVariables, paramsExternalWindow = null) {
      let params = null;
    let paramControl = paramControlVariables;
    if (paramControl != null) params = paramControl;
    if (params != null && data['idCompanyGeneric'] && params[data['idCompanyGeneric']]) params = paramControl;
    //let paramsExternalWindowB = {paramsExternalWindow: paramsExternalWindow};
    let body = JSON.stringify({ data, params, paramsExternalWindow });
    let requestURL =
      this.URL +
      // Joan: De moment...
      //Values.API_RESOURCES.GENERIC +
      //this.reqPattern +
      //Values.GENERIC_REQUEST.RETRIEVE_STRUCTURE;
      'retrieve-structure';
      
    // Joan: afegeixo headers per evitar error a rust. a php no calia. A rust millor fer-ho així
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post(requestURL, body, { headers }).pipe(map((response) => response));
  }

}